import { render, staticRenderFns } from "./CardModalToggleTableItems.vue?vue&type=template&id=15d5638d&scoped=true&"
import script from "./CardModalToggleTableItems.vue?vue&type=script&lang=ts&"
export * from "./CardModalToggleTableItems.vue?vue&type=script&lang=ts&"
import style0 from "./CardModalToggleTableItems.vue?vue&type=style&index=0&id=15d5638d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d5638d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
